import styled from "styled-components";
import { MEDIA_QUERY } from "../../entities/Common";

export const CreateMixStyled = styled.div`
  padding-bottom: 40px;
  .create-mix {
    &__left {
      width: 55.1572327%;
    }
    &__right {
      width: 43.3333333%;
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_HORIZONTAL}) {
    .create-mix {
      &__left {
        width: 50%;
      }
      &__right {
        width: calc(50% - 10px);
      }
    }
  }

  @media (max-width: ${MEDIA_QUERY.TABLET_VERTICAL}) {
    > .generic-flex {
      flex-wrap: wrap;
    }
    .create-mix {
      &__left {
        width: 100%;
      }
      &__right {
        width: 100%;
      }
    }
  }
`;
